import { ColorEnum } from '@/constants/color'
import ModalHeading from '@/features/common/components/ModalHeading'
import ActionButtons from '@/features/pos/components/OrderFinalization/parts/ActionConfirmationModal/parts/ActionButtons'
import { Actions } from '@/features/pos/components/OrderFinalization/parts/ActionConfirmationModal/types'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

export type ActionConfirmationModalContentProps = {
    action: string
} & Actions

const ActionConfirmationModalContent: FC<ActionConfirmationModalContentProps> = ({
    action,
    onConfirm,
    onCancel,
}) => {
    return (
        <View style={styles.container}>
            <ModalHeading>{action}</ModalHeading>
            <ActionButtons onConfirm={onConfirm} onCancel={onCancel} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 32,
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 32,
        paddingHorizontal: 16,
        borderRadius: 16,
        backgroundColor: ColorEnum.GRAY_100,
    },
})

export default ActionConfirmationModalContent
